'use client';

import { useEffect } from 'react';
import { captureClientException } from '@/lib/sentry-client';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    captureClientException(error);
  }, [error]);

  return (
    <html lang="en">
      <body>
        <main
          style={{
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            fontFamily: 'system-ui, sans-serif',
            justifyContent: 'center',
            minHeight: '100vh',
            padding: '1rem',
            textAlign: 'center',
          }}
        >
          <h1>Something went wrong</h1>
          <p>Please try again. If the problem continues, contact Sweetspot support.</p>
          <button onClick={reset} type="button">
            Try Again
          </button>
        </main>
      </body>
    </html>
  );
}
